let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l0OdA")).then(() => parcelRequire('8Bq7p'));